// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./AttenNewRegular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./AttenNewRegularItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./AttenNewMedium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./AttenNewMediumItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./AttenNewBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./AttenNewBoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./AttenNewExtraBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./AttenNewExtraBoldItalic.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* #### Generated By: http://www.cufonfonts.com #### */

@font-face {
  font-family: 'Atten New';
  font-style: normal;
  font-weight: 400;
  src: local('Atten New Regular'), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff');
}

@font-face {
  font-family: 'Atten New';
  font-style: italic;
  font-weight: normal;
  src: local('Atten New Regular Italic'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
}

@font-face {
  font-family: 'Atten New';
  font-style: normal;
  font-weight: 500;
  src: local('Atten New Medium'), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff');
}

@font-face {
  font-family: 'Atten New';
  font-style: italic;
  font-weight: 500;
  src: local('Atten New Medium Italic'), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
}

@font-face {
  font-family: 'Atten New';
  font-style: normal;
  font-weight: 700;
  src: local('Atten New Bold'), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff');
}

@font-face {
  font-family: 'Atten New';
  font-style: italic;
  font-weight: 700;
  src: local('Atten New Bold Italic'), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');
}

@font-face {
  font-family: 'Atten New';
  font-style: normal;
  font-weight: 900;
  src: local('Atten New ExtraBold'), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff');
}

@font-face {
  font-family: 'Atten New';
  font-style: italic;
  font-weight: 900;
  src: local('Atten New ExtraBold Italic'), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff');
}
`, "",{"version":3,"sources":["webpack://./src/fonts/AttenNew/style.css"],"names":[],"mappings":"AAAA,sDAAsD;;AAEtD;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,uFAA6E;AAC/E;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,8FAA0F;AAC5F;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,sFAA2E;AAC7E;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,6FAAwF;AAC1F;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,oFAAuE;AACzE;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,2FAAoF;AACtF;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,yFAAiF;AACnF;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,gGAA8F;AAChG","sourcesContent":["/* #### Generated By: http://www.cufonfonts.com #### */\n\n@font-face {\n  font-family: 'Atten New';\n  font-style: normal;\n  font-weight: 400;\n  src: local('Atten New Regular'), url('./AttenNewRegular.woff') format('woff');\n}\n\n@font-face {\n  font-family: 'Atten New';\n  font-style: italic;\n  font-weight: normal;\n  src: local('Atten New Regular Italic'), url('./AttenNewRegularItalic.woff') format('woff');\n}\n\n@font-face {\n  font-family: 'Atten New';\n  font-style: normal;\n  font-weight: 500;\n  src: local('Atten New Medium'), url('./AttenNewMedium.woff') format('woff');\n}\n\n@font-face {\n  font-family: 'Atten New';\n  font-style: italic;\n  font-weight: 500;\n  src: local('Atten New Medium Italic'), url('./AttenNewMediumItalic.woff') format('woff');\n}\n\n@font-face {\n  font-family: 'Atten New';\n  font-style: normal;\n  font-weight: 700;\n  src: local('Atten New Bold'), url('./AttenNewBold.woff') format('woff');\n}\n\n@font-face {\n  font-family: 'Atten New';\n  font-style: italic;\n  font-weight: 700;\n  src: local('Atten New Bold Italic'), url('./AttenNewBoldItalic.woff') format('woff');\n}\n\n@font-face {\n  font-family: 'Atten New';\n  font-style: normal;\n  font-weight: 900;\n  src: local('Atten New ExtraBold'), url('./AttenNewExtraBold.woff') format('woff');\n}\n\n@font-face {\n  font-family: 'Atten New';\n  font-style: italic;\n  font-weight: 900;\n  src: local('Atten New ExtraBold Italic'), url('./AttenNewExtraBoldItalic.woff') format('woff');\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
